import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//helpers
import { screen } from '@/helpers/screen';

//components
import { Container } from 'components/Grid';

export const VideoHeroWrapper = styled.section`
  position: relative;
  padding-bottom: 100px;
  background: rgb(${getToken('color-background-primary')});

  ${screen.lg} {
    padding-bottom: 80px;
  }

  ${screen.xxlg} {
    padding-bottom: 100px;
  }
`;

export const ContainerStyled = styled(Container)`
  padding: 0;
  width: 100%;
  max-width: calc(100% - 38px);
  margin-top: -100px;
  background: rgb(${getToken('color-background-primary')});
  border-radius: 8px;

  ${screen.md} {
    margin-top: -240px;
    width: calc(100% - 168px);
    max-width: 605px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  }

  ${screen.lg} {
    width: calc(100% - 266px);
    max-width: 835px;
    margin-top: -180px;
  }

  ${screen.xxlg} {
    width: calc(100% - 803px);
    max-width: 1100px;
    margin-top: -200px;
  }
`;

export const MediaWrapper = styled.div`
  margin: 48px auto 0;
  height: 170px;
  width: 100%;
  position: relative;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  ${screen.md} {
    align-self: center;
    height: 340px;
  }

  ${screen.lg} {
    height: 470px;
  }

  ${screen.xxlg} {
    height: 619px;
  }

  & > div > button {
    margin: auto;
    padding: 0;
  }
`;
